import React from 'react'

const toPartsFrom24 = (value24 = '') => {
  if (!value24 || value24.indexOf(':') === -1)
    return { h: '12', m: '00', ap: 'AM' }
  const [hhStr, mmStr] = value24.split(':')
  let hh = parseInt(hhStr || '0', 10)
  const ap = hh >= 12 ? 'PM' : 'AM'
  hh = hh % 12
  if (hh === 0) hh = 12
  return {
    h: String(hh).padStart(2, '0'),
    m: String(parseInt(mmStr || '0', 10)).padStart(2, '0'),
    ap
  }
}

const to24FromParts = (hStr, mStr, ap) => {
  let h = parseInt(hStr || '12', 10)
  const m = parseInt(mStr || '0', 10)
  const isPM = String(ap || 'AM').toUpperCase() === 'PM'
  if (isPM && h < 12) h += 12
  if (!isPM && h === 12) h = 0
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

const compare24 = (a = '', b = '') => {
  if (!a) return -1
  if (!b) return 1
  const [ah, am] = a.split(':').map((n) => parseInt(n || '0', 10))
  const [bh, bm] = b.split(':').map((n) => parseInt(n || '0', 10))
  if (ah !== bh) return ah - bh
  return am - bm
}

export default function TimePicker12({ value24, onChange, min24 }) {
  const { h, m, ap } = toPartsFrom24(value24)

  const hourOptions = Array.from({ length: 12 }, (_, i) =>
    String(i + 1).padStart(2, '0')
  )
  const minuteOptions = [
    '00',
    '05',
    '10',
    '15',
    '20',
    '25',
    '30',
    '35',
    '40',
    '45',
    '50',
    '55'
  ]

  const isHourDisabled = (hour12) => {
    if (!min24) return false
    const candidate = to24FromParts(hour12, '00', ap)
    return compare24(candidate, min24) < 0
  }

  const isMinuteDisabled = (minute) => {
    if (!min24) return false
    const candidate = to24FromParts(h, minute, ap)
    return compare24(candidate, min24) < 0
  }

  const isApDisabled = (ampm) => {
    if (!min24) return false
    const candidate = to24FromParts(h, m, ampm)
    return compare24(candidate, min24) < 0
  }

  return (
    <div className='d-flex gap-2'>
      <select
        className='form-select'
        value={h}
        onChange={(e) => onChange(to24FromParts(e.target.value, m, ap))}
      >
        {hourOptions.map((opt) => (
          <option key={opt} value={opt} disabled={isHourDisabled(opt)}>
            {opt}
          </option>
        ))}
      </select>
      <select
        className='form-select'
        value={m}
        onChange={(e) => onChange(to24FromParts(h, e.target.value, ap))}
      >
        {minuteOptions.map((opt) => (
          <option key={opt} value={opt} disabled={isMinuteDisabled(opt)}>
            {opt}
          </option>
        ))}
      </select>
      <select
        className='form-select'
        value={ap}
        onChange={(e) => onChange(to24FromParts(h, m, e.target.value))}
      >
        <option value='AM' disabled={isApDisabled('AM')}>
          AM
        </option>
        <option value='PM' disabled={isApDisabled('PM')}>
          PM
        </option>
      </select>
    </div>
  )
}
